/**
 * 環境変数の取得（必須項目は欠落で throw）。
 * Vite の `import.meta.env.VITE_*` を実行時に1回検証する。
 *
 * 空文字フォールバックは禁止（fetch が同一オリジンに飛んで本番が静かに壊れる）。
 */

const required = (key: string): string => {
  const value = import.meta.env[key];
  if (typeof value !== 'string' || value === '') {
    throw new Error(
      `${key} is not set. .env.local / .env.production を確認してください。`
    );
  }
  return value;
};

export const API_URL = required('VITE_API_URL');
export const PORTAL_URL = required('VITE_PORTAL_URL');
